import styled from 'styled-components';

export const PageTitle = styled.div`
  margin: 0 auto 30px auto;
  width: auto;
  max-width: 1068px;
  span {
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.28;
    letter-spacing: 0.01px;
    text-align: left;
    color: #619b30;
  }
  div.voltar {
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-right: 20px;
    padding-top: 2px;
    button {
      display: flex;
      align-items: center;
      flex-direction: row;
      border: none;
      background: none;
      color: #619b30;
      font-weight: bold;
    }
  }
`;

export const BoxAuth = styled.div`
  width: 1068px;
  padding: 40px;
  border: solid 0.8px #d9d9d9;
  background-color: #f7f7f7;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
`;

export const Left = styled.div`
  width: 40%;
  height: 350px;
  h4 {
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.13;
    letter-spacing: 0.01px;
    text-align: left;
    color: #282828;
    margin-bottom: 20px;
    span {
      font-weight: bold;
    }
  }

  h3 {
    margin: 20px 0;
  }

  div.ButtonBox {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    button {
      width: 100%;
      max-width: 90px;
    }
    a {
      font-size: 13px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      letter-spacing: 0.01px;
      color: #999;
      display: flex;
      align-items: center;
      height: 30px;
    }
  }
`;

export const BoxLabel = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const Label = styled.p`
  font-size: 13px;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: 0.01px;
  text-align: left;
  color: #282828;
  margin-top: 20px;
  margin-bottom: 8px;
`;

export const Right = styled.div`
  width: 60%;
  height: 350px;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
  }
`;
